import unlimitedOption from '../constants/unlimitedOption';

const getDecrementDisabled = (
value,
allowUnlimitedOption,
disableZero,
allowNegative) =>
{
  if (allowNegative) {
    return false;
  }
  if (disableZero) {
    return allowUnlimitedOption ? value <= unlimitedOption.value : value <= 1;
  }
  return allowUnlimitedOption ? value <= unlimitedOption.value : value <= 0;
};

export default getDecrementDisabled;